import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdArrowBackIos, MdClose, MdDelete } from "react-icons/md";
import "./voucher.css";
import { Ledger_accounts_manager } from "./ledger_accounts_manager.js";
import Update_staff_ledger_account from "./update_staff_ledger_account.jsx";
import { Save_log_history } from "../../log_history_root/save_log_history.js";
import { Verify_stafftype_account } from "../../company_root/staff_account_root/verify_stafftype_account.js";
import { Randomcode } from "../../components_root/rendom_code.js";


export default function Accounts_edit() {
    const servicetablename = "accountingfinancedb";
    const navigate = useNavigate();
    const location = useLocation();
    const [voucherid, setVoucherid] = useState("");
    const [IsLoading2, setIsLoading2] = useState(true);
    const [ledger_accountsdata, setLedger_accountsdata] = useState([]);
    const [accountguid, setaccountguid] = useState();
    const [manage_ledger_accountsdata, setManage_ledger_accountsdata] = useState([]);
    const { Toastshow } = Toast();
    const [manageaccountguid, setManageaccountguid] = useState();
    const [voucher, setVoucher] = useState("");
    const [vouchersdata, setVouchersdata] = useState([]);
    const [voucher_type, setVoucher_type] = useState(0);
    const [docid, setDocid] = useState(Randomcode(28));

    // Read accountguid from navigation state ONLY once
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const accountguids =
            location.state?.accountguid ||
            queryParams.get("accountguid");

        if (!accountguids || accountguids === "null") {
            // Toastshow("Invalid account number: " + accountguid);
            return;
        }

        setaccountguid(accountguids);
        setManageaccountguid(accountguids);
    }, [location]);
    //staff account verify
    const [staffstatus, setStaffstatus] = useState(false);
    const [staffdata, setStaffdata] = useState(null);        // object
    const [accountinfodata, setAccountinfodata] = useState(null); // object

    useEffect(() => {
        const verifyStaffAccount = async () => {
            const result = await Verify_stafftype_account(accountguid);

            if (result.success) {
                setStaffdata(result.data);
                setAccountinfodata(result.accountinfo);
                setStaffstatus(true);
            } else {
                setStaffstatus(false);
            }
        };

        verifyStaffAccount();
    }, [accountguid]);
    // Load ledger account
    useEffect(() => {
        if (!accountguid) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) {
            Toastshow("Company not selected");
            return;
        }
        setIsLoading2(true);
        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "ledger_accounts"),
            where("accountguid", "==", accountguid)
        );

        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const data = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setLedger_accountsdata(data);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Fetch error:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    }, [accountguid]);
    // Fetch Ledger Accounts

    useEffect(() => {
        const fetch_manage_ledger_accounts = () => {
            if (!accountguid) return;
            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            setIsLoading2(true);

            const q = query(
                collection(db, servicetablename, select_company_uid, "ledger_accounts_manager"),
                where("accountguid", "==", accountguid)
            );

            const unsubscribe = onSnapshot(
                q,
                (snapshot) => {
                    const rows = snapshot.docs.map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));

                    setManage_ledger_accountsdata(rows);
                    setIsLoading2(false);
                },
                (error) => {
                    console.error("Error fetching ledger accounts:", error);
                    setIsLoading2(false);
                }
            );

            return unsubscribe;
        };

        const unsubscribe = fetch_manage_ledger_accounts();

        // Cleanup listener when accountguid changes or component unmounts
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [accountguid]);

    useEffect(() => {
        const fetc_hvouchers_info = async () => {
            if (!voucherid) return;

            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            setIsLoading2(true);

            // Correct path: companies/{company_uid}/vouchers
            const productQuery = query(
                collection(db, servicetablename, select_company_uid, "vouchers"),
                where("voucherid", "==", voucherid)
                //  orderBy("indexnumber", "asc")
            );

            const unsubscribe = onSnapshot(
                productQuery,
                (snapshot) => {
                    const vouchers = snapshot.docs.map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));

                    const v = vouchers[0] || {};

                    setVoucher_type(v.voucher_type);
                    setVoucher(v.voucher || "");

                    setIsLoading2(false);
                },
                (error) => {
                    console.error("Error fetching vouchers:", error);
                    setIsLoading2(false);
                }
            );

            return () => unsubscribe();
        };
        fetc_hvouchers_info();
    }, [voucherid]);
    //
    const fetchvouchers = async () => {


        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        setIsLoading2(true);

        // Correct path: companies/{company_uid}/vouchers
        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "vouchers"),
            //   where("voucherid", "==", voucherid)
            //  orderBy("indexnumber", "asc")
        );

        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                setVouchersdata(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };
    useEffect(() => {
        fetchvouchers();
    }, [accountguid]); // IMPORTANT


    const handle_save_manage_account = async () => {
        if (!voucherid || !voucherid.trim()) {
            Toastshow("Please enter voucherid.");
            return;
        }
        if (!manageaccountguid || !manageaccountguid.trim()) {
            Toastshow("Please enter accountguid.");
            return;
        }

        const data = {
            accountsmanagerid: docid,
            voucherid,
            accountguid: manageaccountguid,
            ledger_type: "manage",
            voucher,
            status: false,
            voucher_type
        };
        const result = await Ledger_accounts_manager(data);
        if (result.success) {
            handleCreate(docid);
        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    }
    const handleCreate = async (docid) => {
        const logid = Randomcode(25);
        if (!voucher_type || !voucher_type.trim()) {
            Toastshow("Please Select role type.");
            return;
        }


        const dataupdates = {
            log_id: logid,
            //
            status: true,
            voucher,
            voucher_type,
            ledger_type: "manage",
            // Add other necessary fields here
        };
        create_log(logid, dataupdates, docid, "authority", voucher, voucher);
    };
    const create_log = async (logid, dataupdates, filedid, account_type, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + description;
        const log_data = {
            logid,
            history_type: "authority",
            servicetablename: "accountingfinancedb",
            tablename: "ledger_accounts_manager",
            filedname: "accountsmanagerid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            accountguid,
            description: description,
            account_type: account_type,
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };

    // const create_log = async (account_type, accounts_name, description, verify_note, account_status) => {
    //     const logid = Randomcode(25);
    //     const log_description = "account_type:" + account_type + ", " + accounts_name + ", " + description;

    //     const data = {
    //         logid, 
    //         docidfiled: "accountsmanagerid",
    //         history_type: "ledger book",
    //         tablename: "ledger_accounts_manager",
    //         filedname: "accountguid",
    //         filedid: docid,
    //         servicetablename: "accountingfinancedb",
    //         log_description,
    //         log_status: false,
    //         verify_status: false,
    //         verify_note,
    //         //change info
    //         description: description,
    //         account_type: account_type,
    //         status: account_status,

    //         // Add other necessary fields here
    //     };
    //     const result = await Save_log_history(data);
    //     if (result.success) {
    //         //  navigate(-1);
    //         Toastshow("Saved successfully.");
    //         setDocid(Randomcode(28));
    //     } else {
    //         Toastshow(result.error || "Failed to save voucher.");
    //     }
    // };
    return (
        <div>
            <div className="b-bottom">
                <table>
                    <tr>
                        <td ><div
                            onClick={() => navigate(navigate(-1))}
                            className="button-ui0 text-h2 bold p-2 cursor">
                            <MdArrowBackIos className="icon" />Account edit
                        </div></td>
                        <td width={30}>
                            <div
                                onClick={() => navigate("/accounting?page=vouchers_master")}
                                className="button-ui0 p-2 cursor"
                            >
                                <MdClose className="icon" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div className="post-container p-2">
                <div className="post_updates b-1 rounded p-11">
                    <div className="ui-grid-home-items ">
                        {IsLoading2 ? (
                            <></>
                        ) : ledger_accountsdata.length === 0 ? (
                            <div className="text-h2 bold p-5">No account found</div>
                        ) : (
                            ledger_accountsdata.map((row) => (
                                <div
                                    className="ui-items m-1 items-back  "
                                    key={row.id}
                                >

                                    <table className="b-bottom">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div
                                                        className="button-ui0 bold"
                                                        style={{
                                                            color: row.status ? "green" : "red",
                                                        }}
                                                    >
                                                        {row.status ? "Activate" : "Deactivate"}
                                                    </div>
                                                </td>
                                                <td width={130} className="text-h3 text-r">
                                                    {row.date_time?.toDate ? (
                                                        <>
                                                            {row.date_time
                                                                .toDate()
                                                                .toLocaleDateString()}{" "}
                                                            {row.date_time
                                                                .toDate()
                                                                .toLocaleTimeString()}
                                                        </>
                                                    ) : (
                                                        <div className="contact-details">No date</div>
                                                    )}
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>

                                    < Update_staff_ledger_account accountguid={row.accountguid} />
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <div className="post_div">
                    <div className="ui-grid">
                        <div className="p-1 ui-items">
                            <div className="text-h3">Set operator authority to manage all related services for the selected voucher.</div>
                            <select
                                className="bold"
                                onChange={(e) => setVoucherid(e.target.value)}
                            >
                                <option value="0">Select voucher</option>

                                {vouchersdata?.map((item, index) => (
                                    <option key={index} value={item.voucherid}>
                                        {item.voucher}
                                    </option>
                                ))}
                            </select>
                            {voucherid !== "0" && (
                                <div className="b-1 p-1 rounded m-top">
                                    <table>
                                        <tr>
                                            <td width={90} ><a className="text-h3 text-off">Voucherid</a></td>
                                            <td  ><a className="text-h3 fcap">{voucherid}</a></td>
                                        </tr>
                                        <tr>
                                            <td width={90} ><a className="text-h3 text-off">Voucher</a></td>
                                            <td  ><a className="text-h2 bold fcap">{voucher}</a></td>
                                        </tr>
                                        <tr>
                                            <td  ><a className="text-h3 text-off">Voucher type</a></td>
                                            <td  ><a className="text-h2 bold fcap">{voucher_type}</a></td>
                                        </tr>


                                       
                                    </table>
                                    <div className="button-ui p-22 fill text-h2 cursor" onClick={() => handle_save_manage_account()}>Assign Authority</div>
                                </div>
                            )} 
                        </div>
                    </div>
                    {IsLoading2 ? (
                        null
                    ) : manage_ledger_accountsdata.length === 0 ? (
                        <div>data not find</div>
                    ) : (
                        <div className="ui-grid">
                            {manage_ledger_accountsdata.map((row) => (
                                <div key={row.id} className="ui-items items-back b-1 rounded p-11">
                                    <table >
                                        <tbody >
                                            <tr>
                                                <table>
                                                    <tr> <td>
                                                        <div className="text-h2 bold fcap">
                                                            {row.voucher || "No account found"}
                                                        </div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td width={130} className='text-h3'>
                                                            Create: {row.date_time?.toDate ? (
                                                                <>
                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className='contact-details'>No date</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td> {row.status ? "Activate" : "Deactivate"}</td>
                                                    </tr>
                                                </table>


                                                <td width={100} >
                                                    <table>
                                                        <tr>
                                                            <td  >
                                                                <div className="text-h2 fcap">
                                                                    {row.voucher_type || "N/A"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td >
                                                                <div className="text-h2 bold">
                                                                    {row.ledger_type || "N/A"}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td >
                                                                <div className="text-h2 bold">
                                                                    {row.mathed || ""}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width={30}>
                                                    {row.account_type === "master" ? (<>Master</>) : (<MdDelete onClick={() => navigate("/accounting?page=delete_master&table=ledger_accounts_manager&filed=accountsmanagerid&history_type=delete&filedid=" + row.accountsmanagerid + "&description=Ledger Settings: " + row.name)} className="icon red cursor" />)

                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ))}

                        </div>
                    )}


                </div>
            </div>
        </div>
    );
}
